import React from "react";
// import ArrowLeftBorder from "../../../assets/svg/arrow-left-border.svg";
// import ArrowRightBorder from "../../../assets/svg/arrow-right-border.svg";
import { InstagramIcon } from "../../../../assets/svgs/common/instagram.svg";
import { Button } from "../../../../components/ui/button";
// import { InstagramEmbed } from "react-social-media-embed";

import Spinner from "../../../../components/spinner.components";
import { Link, useParams } from "react-router-dom";
import RejectionCard from "../../../../components/rejection-card.components";
import useUserStore from "../../../../store/socials.store";
import type { ISocial } from "../../../../types/models/social.models.types";
import { ApproveButton } from "../../../../components/action-buttons/socials/approve-button.components";
import { useGetSocialByIdAdminHttp } from "../../../../hooks/http/admin/socials/get-social-by-id.admin.http";
import { useToast } from "../../../../hooks/use-toast";
import millify from "millify";
import { handleHttpError } from "../../../../utils/utils";
import { RejectButton } from "../../../../components/action-buttons/socials/reject-button.component";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../../../components/ui/tabs";
import UserTransaction from "../../../../components/user-transaction.components";
import UserParticipationHistory from "../../../../components/participation-history.components";

import { Youtube } from "lucide-react";

export enum SocialSliderMenuTabs {
  USER_INFO = "user-info",
  TRANSACTIONS = "transactions",
  PARTICIPATION_HISTORY = "participation-history",
}

export const SocialsSliderMenuPartial: React.FunctionComponent = () => {
  const { userId } = useParams();
  const { execute: getSocialsByIdHttp, fetching: fetchingSocial } =
    useGetSocialByIdAdminHttp();
  const [socialData, setSocialData] = React.useState<ISocial>();
  const { removeById } = useUserStore();
  const { toast } = useToast();
  const [activeTab, setActiveTab] = React.useState<SocialSliderMenuTabs>(SocialSliderMenuTabs.USER_INFO);



  async function getSocial() {
    if (userId) {
      const response = await getSocialsByIdHttp({
        body: null,
        pathParams: { id: userId },
      });
      if (!response.success) {
        return handleHttpError(response, toast);
      }
      setSocialData(response.data.social);
    }
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  React.useEffect(() => {
    getSocial();
  }, [userId]);

  function RenderPost() {
    if (socialData?.applicationStatus.status === "rejected") {
      return (
        <div className="flex flex-col gap-5">
          <span className="font-semibold text-2xl"> Reason of rejection </span>
          <RejectionCard
            message={socialData?.applicationStatus.message || ""}
          />
        </div>
      );
    }
    return null;
  }

  function RenderButtons() {
    if (!userId) return;

    if (window.location.pathname.includes("favorites")) {
      return <></>;
    }
    if (window.location.pathname.includes("fixed-payouts")) {
      return <></>;
    }

    if (socialData?.applicationStatus.status === "approved") {
      return (
        <div className="w-full">
          <div className="flex items-center gap-4 w-full">
            <Button className="flex-1 bg-tertiarybuttonbg py-6 border border-border rounded-md font-semibold tracking-wider">
              Save changes
            </Button>
            <Link className="flex-1" to={`/admin/socials/${userId}/reject`}>
              <Button className="bg-rejectbuttonbg py-6 border border-rejectbuttonborder w-full font-semibold text-rejectbuttontext tracking-wider">
                Reject
              </Button>
            </Link>
          </div>
        </div>
      );
    }
    if (socialData?.applicationStatus.status === "applied") {
      return (
        <div className="w-full">
          <div className="flex items-center gap-4 w-full">
            <ApproveButton
              className="flex-1 py-6"
              social={socialData}
              removeById={removeById}
            />
            <RejectButton className="flex-1 py-6" social={socialData} />
          </div>
        </div>
      );
    }
    if (socialData?.applicationStatus.status === "rejected") {
      return (
        <div className="w-full">
          <div className="flex items-center gap-4 w-full">
            <ApproveButton
              className="flex-1 py-6"
              social={socialData}
              removeById={removeById}
            />
          </div>
        </div>
      );
    }
    return null;
  }

  return fetchingSocial ? (
    <div className="flex justify-center items-center w-full h-full">
      <Spinner width={30} />
    </div>
  ) : (
    <>
      <div className="flex flex-col w-full">
        <div className="flex flex-col gap-8 py-5 pb-10 pl-5 w-full">
          <div className="flex items-center gap-6">
            {socialData?.youtube ? (
              <img
                src={socialData?.youtube.profileImage || "/static/profile.png"}
                className="rounded-xl w-24 h-24"
                alt=""
              />
            ) : (
              <img
                src={socialData?.profileImage || "/static/profile.png"}
                className="rounded-xl w-24 h-24"
                alt=""
              />
            )}

            <div className="flex flex-col justify-between gap-2 h-24">
              <p className="font-semibold text-xl leading-6">
                {socialData?.creator?.name}
              </p>
              <p className="font-semibold text-sm tracking-wider">
                {socialData?.creator?.phoneNumber.slice(0, 3)}{" "}
                {socialData?.creator?.phoneNumber.slice(3, 16)}
              </p>
              {socialData?.youtube ? (
                <Link
                  target="_blank"
                  to={`https://youtube.com/@${socialData.youtube?.channelHandle}/`}
                >
                  <Button className="bg-tertiarybuttonbg px-10 py-5 border border-border font-semibold tracking-wider">
                    View Youtube
                  </Button>
                </Link>
              ) : (
                <Link
                  target="_blank"
                  to={`https://instagram.com/${socialData?.handle}/`}
                >
                  <Button className="bg-tertiarybuttonbg px-10 py-5 border border-border font-semibold tracking-wider">
                    View Instagram
                  </Button>
                </Link>
              )}
            </div>
          </div>
        </div>
        <Tabs
          defaultValue={activeTab}
          value={activeTab}
          onValueChange={(value) => setActiveTab(value as SocialSliderMenuTabs)}
        >
          <TabsList className="flex bg-tertiarybuttonbg rounded-lg w-full h-16">
            <TabsTrigger
              className="flex-1 data-[state=active]:bg-primarybuttonbg border-none rounded-lg h-14 data-[state=active]:text-black"
              value={SocialSliderMenuTabs.USER_INFO}
            >
              User info
            </TabsTrigger>
            <TabsTrigger
              className="flex-1 data-[state=active]:bg-primarybuttonbg border-none rounded-lg h-14 data-[state=active]:text-black"
              value={SocialSliderMenuTabs.TRANSACTIONS}
            >
              Transactions
            </TabsTrigger>
            <TabsTrigger
              className="flex-1 data-[state=active]:bg-primarybuttonbg border-none rounded-lg h-14 data-[state=active]:text-black"
              value={SocialSliderMenuTabs.PARTICIPATION_HISTORY}
            >
              Campaign History
            </TabsTrigger>
          </TabsList>
          <TabsContent value={SocialSliderMenuTabs.USER_INFO} className="flex flex-col w-full">
            <div className="flex flex-col gap-8 py-5 pb-10 pl-5 w-full">
              <div className="flex justify-between items-center max-w-[500px]">
                <div className="flex flex-col">
                  <span className="text-lg text-secondary">Gender</span>
                  <p className="text-xl">{socialData?.gender}</p>
                </div>
                <div className="flex flex-col pl-5 border-border border-l">
                  <span className="text-lg text-secondary">City</span>
                  <p className="text-xl">{socialData?.location?.address}</p>
                </div>
                <div className="flex flex-col pl-5 border-border border-l">
                  <span className="text-lg text-secondary">Type</span>
                  <p className="text-xl">{socialData?.creatorType}</p>
                </div>
              </div>
              <div className="flex flex-col gap-2">
                <span className="text-lg text-secondary"> Content Type</span>

                <div className="flex flex-wrap items-center gap-2 w-full">
                  {socialData?.contentType?.map((tag) => {
                    return (
                      <span
                        key={tag}
                        className="flex items-center gap-1 bg-tertiarybuttonbg backdrop-blur-sm px-4 py-2 border border-border rounded-full w-fit font-bold text-lg"
                      >
                        <span className="capitalize">{tag}</span>

                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-8 py-5 w-full">
              <div className="flex flex-col justify-center items-center gap-2 bg-tertiarybuttonbg p-5 border border-border rounded-xl w-full">
                <p className="text-sm text-tertiary">Wallet balance</p>
                <p className="text-xl">₹{socialData?.creator?.walletBalance}</p>
              </div>
            </div>
            {socialData?.youtube ? (
              <div className="flex flex-col gap-8 py-10 pl-5 border-border border-b w-full">
                <p className="text-xl">Creator overview</p>
                <div className="flex flex-col gap-4">
                  <div className="flex justify-between items-center">
                    <div className="flex flex-col flex-1 text-start">
                      <span className="text-lg text-secondary">
                        No.of Subscribers
                      </span>
                      <p className="flex items-center gap-2 text-xl">
                        <Youtube className="w-8 h-8" />
                        {millify(socialData?.youtube.subscriberCount || 0)}
                      </p>
                    </div>
                    <div className="flex flex-col flex-1 pl-16 border-border border-l text-start">
                      <span className="text-lg text-secondary">
                        Average views
                      </span>
                      <p className="flex items-center gap-2 text-xl">
                        {millify(
                          socialData?.youtube.metrics?.averageViews || 0,
                        )}
                      </p>
                    </div>
                  </div>
                  <hr className="opacity-15" />
                  <div className="flex justify-between items-center">
                    <div className="flex flex-col flex-1 text-start">
                      <span className="text-lg text-secondary">
                        Engagement rate
                      </span>
                      <p className="flex items-center gap-2 text-xl">
                        {socialData?.youtube.metrics?.engagementRate?.toFixed(
                          2,
                        )}{" "}
                        %
                      </p>
                    </div>
                    <div className="flex flex-col flex-1 pl-16 border-border border-l text-start">
                      <span className="text-lg text-secondary">
                        Total posts
                      </span>
                      <p className="flex items-center gap-2 text-xl">_ posts</p>
                    </div>
                  </div>{" "}
                </div>
              </div>
            ) : (
              <div className="flex flex-col gap-8 py-10 pl-5 border-border border-b w-full">
                <p className="text-xl">Creator overview</p>
                <div className="flex flex-col gap-4">
                  <div className="flex justify-between items-center">
                    <div className="flex flex-col flex-1 text-start">
                      <span className="text-lg text-secondary">
                        No.of Followers
                      </span>
                      <p className="flex items-center gap-2 text-xl">
                        <InstagramIcon className="w-8 h-8" />
                        {millify(socialData?.followersCount || 0)}
                      </p>
                    </div>
                    <div className="flex flex-col flex-1 pl-16 border-border border-l text-start">
                      <span className="text-lg text-secondary">
                        Average views
                      </span>
                      <p className="flex items-center gap-2 text-xl">
                        {millify(socialData?.averageViews || 0)}
                      </p>
                    </div>
                  </div>
                  <hr className="opacity-15" />
                  <div className="flex justify-between items-center">
                    <div className="flex flex-col flex-1 text-start">
                      <span className="text-lg text-secondary">
                        Engagement rate
                      </span>
                      <p className="flex items-center gap-2 text-xl">
                        {socialData?.engagementRate?.toFixed(2)} %
                      </p>
                    </div>
                    <div className="flex flex-col flex-1 pl-16 border-border border-l text-start">
                      <span className="text-lg text-secondary">
                        Total posts
                      </span>
                      <p className="flex items-center gap-2 text-xl">_ posts</p>
                    </div>
                  </div>{" "}
                </div>
              </div>
            )}
          </TabsContent>
          <TabsContent value={SocialSliderMenuTabs.TRANSACTIONS} className="flex flex-col w-full">
            <UserTransaction social={socialData as ISocial} />
          </TabsContent>

          <TabsContent value={SocialSliderMenuTabs.PARTICIPATION_HISTORY} className="flex flex-col w-full">
            <UserParticipationHistory social={socialData as ISocial} />
          </TabsContent>
        </Tabs>
      </div>
      {activeTab === SocialSliderMenuTabs.USER_INFO && <RenderPost />}
      {activeTab === SocialSliderMenuTabs.USER_INFO && (
        <div className="w-full">
          <RenderButtons />
        </div>
      )}
    </>
  );
};
